import { useContext, useState } from "react";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import { TableDataContext } from "../../Contexts/TableDataContext";
import { useLocation } from "react-router";
import axios from "axios";
import moment from 'moment';
import { UserContext } from "../../Contexts/UserContext";
import Constants from "../../Constants";


export const ExportDirectoryExcel = ({
  modules,
  url,
  fileName,
  module_type,
  type,
  onClose,
}) => {
  let dealColumns = {};
  let transactionCategory = [];
  const [isExporting, setisExporting] = useState(false);

  const [open, setOpen] = useState(false);
  const location = useLocation();
  const {  tableInvestorId, data } =
    useContext(TableDataContext);
  const { getToken, logout } = useContext(UserContext);
  const [reachedLimitPopup, setReachedLimitPopup] = useState({ show: false, message: "" })


  const { monthPickerValue, refineSearchFilters } = useContext(PeFilterContext);
  const [requestBodyForExport, setRequestBodyForExport] = useState({
        Export_from: "list",
        with_investments: true,
        with_transaction: true,
        is_refine: false,
        type: "pe_vc_investment",
        investor_id: tableInvestorId,
        deal_ids: data.all_deal_ids,
        module_type: "pe",
        with_agg_hide: 0,
        profile_columns: ["ALL"],
        inv_deal_columns: [
          "Company Name",
          "Investors",
          "Industry",
          "Sector",
          "Date",
          "Amount(INR Cr)",
          "Amount(US$M)",
          "Exit Status",
        ],
        transaction_category: [
          "investments",
          "exits",
          "ipos",
          "angel",
          "incubation",
        ],
        exit_deal_columns: [
          "Portfolio Company",
          "Exiting Investors",
          "Industry",
          "Sector_Business Description",
          "Deal Date",
          "Deal Amount (US$M)",
          "Exit Status",
        ],
        ipo_deal_columns: [
          "Portfolio Company",
          "Selling Investors",
          "Industry",
          "Sector_Business Description",
          "Date",
          "Exit Status",
        ],
        angel_deal_columns: [
          "Company",
          "Investors",
          "Industry",
          "Sector",
          "Date",
          "Exited",
        ],
        incb_deal_columns: [
          "Company",
          "Incubator",
          "Industry",
          "Sector",
          "Date",
          "Status",
        ],
        date_range: {
          "from_date": moment(monthPickerValue[0]).format("YYYY-MM-DD"),
          "to_date": moment(monthPickerValue[1]).format("YYYY-MM-DD"),
        },
      });

  const [options, setOptions] = useState([
    { id: 1, option: "with Investment", isChecked: true },
    { id: 2, option: "without investment", isChecked: false },
  ]);

  const onCheckChange = (option) => {
    console.log("opt", option);
    if (option.id === 1) {
      setOptions([
        { id: 1, option: "with Investment", isChecked: true },
        { id: 2, option: "without investment", isChecked: false },
      ]);
      setRequestBodyForExport({
        Export_from: "list",
        with_investments: true,
        with_transaction: true,
        is_refine: false,
        type: "pe_vc_investment",
        investor_id: tableInvestorId,
        deal_ids: data.all_deal_ids,
        module_type: "pe",
        with_agg_hide: 0,
        profile_columns: ["ALL"],
        inv_deal_columns: [
          "Company Name",
          "Investors",
          "Industry",
          "Sector",
          "Date",
          "Amount(INR Cr)",
          "Amount(US$M)",
          "Exit Status",
        ],
        transaction_category: [
          "investments",
          "exits",
          "ipos",
          "angel",
          "incubation",
        ],
        exit_deal_columns: [
          "Portfolio Company",
          "Exiting Investors",
          "Industry",
          "Sector_Business Description",
          "Deal Date",
          "Deal Amount (US$M)",
          "Exit Status",
        ],
        ipo_deal_columns: [
          "Portfolio Company",
          "Selling Investors",
          "Industry",
          "Sector_Business Description",
          "Date",
          "Exit Status",
        ],
        angel_deal_columns: [
          "Company",
          "Investors",
          "Industry",
          "Sector",
          "Date",
          "Exited",
        ],
        incb_deal_columns: [
          "Company",
          "Incubator",
          "Industry",
          "Sector",
          "Date",
          "Status",
        ],
        date_range: {
          "from_date": moment(monthPickerValue[0]).format("YYYY-MM-DD"),
          "to_date": moment(monthPickerValue[1]).format("YYYY-MM-DD"),
        },
      });
    } else {
      setOptions([
        { id: 1, option: "With Investment", isChecked: false },
        { id: 2, option: "without investment", isChecked: true },
      ]);
      setRequestBodyForExport({
        Export_from: "list",
        with_investments: false,
        with_transaction: false,
        is_refine:
          refineSearchFilters[location.pathname] != undefined ? true : false,
        type: type,
        investor_id: tableInvestorId,
        module_type: module_type,
        with_agg_hide: 0,
        profile_columns: ["ALL"],
        inv_deal_columns: ["ALL"],
        transaction_category: transactionCategory,
        exit_deal_columns: [],
        ipo_deal_columns: ["ALL"],
        angel_deal_columns: ["ALL"],
        incb_deal_columns: ["ALL"],
        date_range: {
          from_date: moment(monthPickerValue[0]).format("YYYY-MM-DD"),
          to_date: moment(monthPickerValue[1]).format("YYYY-MM-DD"),
        },
      });
    }
  };

  const downloadExcel = async ({ fileName = "file" }) => {
    setisExporting(true);
    const result = await axios(`${url}`, {
      method: "POST",
      data: JSON.stringify(requestBodyForExport),
      headers: {
        "Content-Type": "application/json",
        "Authorization": getToken(),
      },
      responseType: "blob",
    })
      .then((response) => {
        setisExporting(false);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${fileName}.xlsx`);
        document.body.appendChild(link);
        link.click();
        return true;
      })

      .catch(async (error) => {

        console.log("downloadExcel - error", error);
        if (error?.response?.status == Constants.sessionTerminatedStatus) {
            logout()
        } else if (error?.response?.status == 400) {
            const dataAsText = await error?.response?.data?.text()
            const parsedData = JSON.parse(dataAsText)
            return parsedData?.message
        }
    });
    return result;
  };

  const onExportClick = async () => {
    setOpen(true);
    // const selectedInitial = filterData?.initial?.find(filter => filter?.isChecked);

    const result = await downloadExcel({ fileName: fileName })
    console.log(result, "result");
    if (result === true) {
        onClose()
    } else {
        setReachedLimitPopup({ show: true, message: result })
    }
  };

  if (reachedLimitPopup.show) {
    return <div className='flex font-sans_book_body cursor-default justify-center items-center z-10 fixed left-0 top-0 w-screen h-screen  bg-gray-500 bg-opacity-75 transition-opacity'>
        <div className='relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 mx-4 md:mx-0 w-[50%]'>
            {/* Header */}
            <div className='w-full flex flex-col '>
                <div className="mt-3 text-center sm:mt-0 px-5 py-3 sm:ml-4 sm:text-left">
                    <h1 className='text-left py-1 text-lg font-bold leading-6 text-gray-900'>Alert!</h1>
                    <div className="mt-4 ">
                        <p className="text-sm text-gray-500 text-start">{reachedLimitPopup.message}</p>
                    </div>
                </div>
            </div>
            <div className='flex bg-gray-50 px-4 pb-3 flex-row-reverse'>
                <button onClick={onClose} className='inline-flex w-full justify-center font-sans_bold_body rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none  sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm'>
                    Close
                </button>
            </div>
        </div>
    </div>
  }

  return (
    <>
      {modules === "investor" ? (
        <div className="flex font-sans_book_body cursor-default justify-center items-center z-10 fixed left-0 top-0 w-screen h-screen  bg-gray-500 bg-opacity-75 transition-opacity">
            <div className="flex flex-col w-[95%] md:w-[25%] h-[38%] bg-white rounded-lg overflow-hidden">
              <div className="w-full flex flex-col  p-4">
                <div className="w-full">
                  <h1 className="text-left py-1 text-lg font-bold leading-6 text-gray-900">
                    Export
                  </h1>
                  <h1 className="text-left text-sm leading-5 text-gray-500">
                    How do you prefer to export?
                  </h1>
                </div>
              </div>
          <div className="h-[40%] w-full flex flex-col overflow-auto border-gray-200 border">
            {options.map((option) => (
              <div
                key={option.id}
                className={`transition ease-in-out delay-150 justify-between  flex text-left  py-2 pr-2 pl-3 w-full font-sans_medium_body font-medium text-gray-700 border-b border-gray-100 md:w-auto ${
                  option.isChecked ? "bg-gray-200" : "hover:bg-gray-50"
                }`}
              >
                <span className="flex text-[13px] items-center">
                  <input
                    id={option.id}
                    className="mr-2"
                    name={option.option}
                    checked={option.isChecked}
                    onChange={() => onCheckChange(option)}
                    type="radio"
                    />
                  <label key={option.id} htmlFor={option.id}>
                    {option.option}
                  </label>
                </span>
              </div>
            ))}
          </div>
          <div className="flex bg-gray-50 px-4 py-3 flex-row-reverse">
            <button
              type="submit"
              value="submit"
              onClose={() => setOpen(false)}
              onClick={isExporting ? null : onExportClick}
              disabled={isExporting}
              className="inline-flex w-full justify-center rounded-md border border-transparent font-sans_bold_body font-medium text-white bg-[#BC8B20] px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-[#a37517] ml-3 sm:w-auto text-sm"
            >
              {isExporting ? (
                <span className="flex items-center ">
                  <span role="status">
                    <svg
                      className="  mr-2 w-4 h-4 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                        />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                  </span>
                  Exporting
                </span>
              ) : (
                "Export"
              )}
            </button>
            <button
              onClick={onClose}
              className="items-center inline-flex w-full justify-center font-sans_bold_body rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none  sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
            >
              Close
            </button>
          </div>
        </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};
